import { AxiosInstance } from 'axios'
import { PlaybookListResponse } from '@dc-shared-web/hooks/api/cl-cs/types'

export const fetchTeamPlaybooks = async (
  apiClient: AxiosInstance,
  params: {
    crunchUuids: string
    page?: number
  }
) => {
  const { data } = await apiClient.get<PlaybookListResponse>(
    '/api/checklist-data',
    {
      params: {
        page: params.page || 1,
        crunch_uuids: params.crunchUuids,
        limit: 100,
        type: 'playbook',
        short: 'true',
      },
    }
  )

  return data
}
